var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-wizard',{attrs:{"form-data":_vm.formData,"item":_vm.item,"namespace":_vm.namespace,"title":_vm.title,"icon":_vm.icon,"store":_vm.store,"store-action":_vm.storeAction},on:{"update:formData":function($event){_vm.formData=$event},"update:form-data":function($event){_vm.formData=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }